import React from 'react';
import { getB2CRedirectSignInUrl } from "../../utils/UrlConstants";
import ApplicationCard from '../common/ApplicationCard';

const B2CSignIn: React.FC = () => {
  const handleSignIn = () => {
    console.log('Initiating B2C sign-in...');
    window.location.href = getB2CRedirectSignInUrl();
  };

  return (
    <div onClick={handleSignIn} style={{ cursor: 'pointer' }}>
      <ApplicationCard
        title="B2C Log In"
        description="External Users SignIn"
        url={null}
      />
    </div>
  );
};

export default B2CSignIn;